import React from 'react';
import { Helmet } from 'react-helmet';
import { useAppSelector } from '../../store';

// const localeByLang = {
//   ru: 'ru-RU',
//   en: 'en-US'
// };

export default function Head() {
  const lang = useAppSelector((state) => state.site.lang);
  const description = useAppSelector((state) => state.site.description);
  const appleTouchIcon = useAppSelector((state) => state.site.appleTouchIcon);
  const favicon = useAppSelector((state) => state.site.favicon);

  const title = `Admin  `;
  // const langHtml = localeByLang[lang];

  return (
    <Helmet htmlAttributes={{ lang: lang }}>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {favicon && <link rel="icon" href={favicon} type="image/png" />}
      {appleTouchIcon && <link rel="apple-touch-icon" href={appleTouchIcon} />}
    </Helmet>
  );
}
